import { faClock } from '@fortawesome/pro-regular-svg-icons';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Button } from '#src/atoms/buttons/Button/index.tsx';
import { FontAwesomeIcon } from '#src/atoms/icons/index.tsx';
import { Vertical } from '#src/atoms/layout/flex/index.tsx';
import { HeadlineL, LabelM } from '#src/atoms/typography/index.tsx';
import { glossary } from '#src/lib/glossary.ts';

const Content = styled(Vertical).attrs({ gap: 2 })`
  align-items: flex-start;
  height: 100%;
`;

const Actions = styled(Vertical).attrs({ gap: 0 })`
  flex-grow: 1;
  width: 100%;
  justify-content: flex-end;
`;

export const Confirmation = ({ onClick }: { onClick: () => void }) => {
  return (
    <Content>
      <FontAwesomeIcon size="2xl" icon={faClock} />
      <HeadlineL as="h3">
        <FormattedMessage
          id="UnblockWallet.Confirmation.title"
          defaultMessage="We’re reviewing your documents"
        />
      </HeadlineL>
      <LabelM>
        <FormattedMessage
          id="UnblockWallet.Confirmation.descriptionNotify"
          defaultMessage="We’ll notify you once we validate your documents."
        />
      </LabelM>
      <LabelM>
        <FormattedMessage
          id="UnblockWallet.Confirmation.meantime"
          defaultMessage="In the meantime, you can pick up right where you left off."
        />
      </LabelM>
      <Actions>
        <Button fullWidth size="medium" color="primary" onClick={onClick}>
          <FormattedMessage {...glossary.done} />
        </Button>
      </Actions>
    </Content>
  );
};
